<script>
    import { onMount } from "svelte";
    import Navbar from "./UI/Navbar.svelte";
    import WPNModal from "./WPNModal.svelte";
    import LPMainView from "./UI/LeftSidePanel/LPMainView.svelte";
    import dbData from "./Stores/utilityDBStore.js";
    import sysData from "./Stores/systemStore.js";
    import schemaData from "./Stores/wpn2SchemaStore.js";
    import mapPrefs from "./Stores/mapPreferencesStore.js";
    import { allCategories, coordinateOfMappable, firstItemWithValueForKey } from "./scripts/wpn2Model.js";
    import { initMapManager, refreshMap, searchDatabase, panMapToItem } from "./scripts/viewMap.js";
    import { fetchCurrentAuthToken, formRequestAction } from "./scripts/awsUtils.js";
    import { createEventDispatcher } from "svelte";
    import browseOpts from "./Stores/browseOptionsStore";

    const apiUrl = process.env.VITE_API_URL;
    const apiDB = process.env.VITE_API_DB;
    const apiALFXSL = process.env.VITE_API_ALFXSL;
    const apiALFXSEN = process.env.VITE_API_ALFXSEN;
    const apiCORR = process.env.VITE_API_CORR;
    const dispatch = createEventDispatcher();
    export let hasMapLoaded;
    let mapWPN;
    let itemToSelect = null;
    /** Search Category is TBD */
    let searchCat = null;
    /** Modal mode = none, support, create-edit, view or analysis */
    let modalMode = "none";
    let detailItem = null;

    // ALFX_DEBUG: "item_logo" not found in Related Items
    // ALFX_DEBUG: Test playing sound in mobile safari from an audio element
    // ALFX_DEBUG: Mobile CSS: hide utility title, max length for sign-in box
    // ALFX_DEBUG: On iPad, system button is off-screen

    // ALFX_TODO: CORR: Test export of sound locations & feedback
    // ALFX_TODO: Show Pipe Nodes as pipe connections
    // ALFX_TODO: Add Feedback to drop-down types
    onMount(async () => {
        loadMap();
    });

    window.reviewClicked = (mappable) => {
        if (mappable != null) {
            detailItem = mappable;
            searchCat = allCategories().find((x) => x.entities.includes(mappable.entity)) ?? "";
        }
    };

    function loadMap() {
        if (hasMapLoaded == true) {
            populateMap();
            return;
        }
        mapkit.init({
            authorizationCallback: function (done) {
                done(
                    // Has domain restriction
                    // "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlRLWDhCRDRBSDgifQ.eyJpc3MiOiJLWjZYVDk3WUVVIiwiaWF0IjoxNjQxMzkzMDA2LCJleHAiOjE2NzI4NzY4MDAsIm9yaWdpbiI6Imh0dHBzOi8vKi53cG42NC5jb20ifQ.8fnofnGRkiUkKB4ZzllUPOl04v3cP4GV7jV5Mnn1zWTpHWzMaBMZ1yeYhGdEAwqbI8gb48A5iLr6FvEiGP9IkQ"
                    // No domain restriction: can be used with localhost:5000, valid until Feb 5, 2023.
                    // "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlRLWDhCRDRBSDgifQ.eyJpc3MiOiJLWjZYVDk3WUVVIiwiaWF0IjoxNjQxMzM0NDg0LCJleHAiOjE2NzI3OTA0MDB9.9CLFX87i0h9V7aSxGT57Y5p53k8HsxK056a7--54mQt-acC2o1yHmJx2GBrUDmWpvG6OzJt4n8_KQEKso0LJ9w"
                    // No domain restriction: can be used with localhost:5000, valid until April 8, 2025.
                    // "eyJhbGciOiJFUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlRLWDhCRDRBSDgifQ.eyJpc3MiOiJLWjZYVDk3WUVVIiwiaWF0IjoxNzEyNjEzMjk2LCJleHAiOjE3NDQwNzA0MDB9.WMbE8MozhDKr-CmhlYxlefy670bl4FufxLVAOjoxCbSa8b6U-RqKpoC4zkSlGkT5JwmVyKGCaR2ieqANerAhQQ"
                    // PRODUCT: Domain restrictions: wpn64.com
                    "eyJraWQiOiI5NTNBWFVTQTc1IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJLWjZYVDk3WUVVIiwiaWF0IjoxNzQ0MTQzNzkzLCJvcmlnaW4iOiJ3cG42NC5jb20ifQ.TmqJjcvkF8o09a_lfHysLLc-MzyUGwVtCMKOTxs0MPLWzl444jdSJi5tomyNdzmML-Y40OOxLl3zhHBLsZyOCg"
                    // DEVELOPMENT: Domain restriction: local host
                    // "eyJraWQiOiI4R1IyOTI2SzdXIiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJLWjZYVDk3WUVVIiwiaWF0IjoxNzQ4OTYzMzgyLCJleHAiOjE3NDk2MjUxOTl9.v02gMG7L_cAzbS4ZaSbeAhbhSkSFymcqFjhkTNsq8Tm0HjuejEM7WRHuga9mzknZ7pEVsnsgiIquIWpyJQYUjg"
                );
            },
        });
        // https://developer.apple.com/documentation/mapkitjs/mapkit/map/handling_map_events
        // TODO: Consider getting Apple maps from NPM: https://www.npmjs.com/package/apple-mapkit-js
        mapkit.addEventListener("configuration-change", function (event) {
            switch (event.status) {
                case "Initialized":
                    // MapKit JS initialized and configured.
                    dispatch("map-loaded");
                    populateMap();
                    break;

                case "Refreshed":
                    // MapKit JS configuration updated.
                    console.log("MapKit refreshed");
                    break;
            }
        });
        mapkit.addEventListener("error", function (event) {
            switch (event.status) {
                case "Unauthorized":
                    console.log("MapKit unauthorized", event);
                    break;

                default:
                    console.log("MapKit error", event);
                    break;
            }
        });
    }

    // Heat map possibility:  https://github.com/pa7/heatmap.js/blob/develop/README.md
    async function populateMap() {
        try {
            let promise = new Promise(fetchCurrentAuthToken);
            promise.then((value) => getDB());
        } catch (error) {
            console.log(error);
        }
    }

    function closeLeftPanel() {
        if ($dbData.modifications.updated.length > 0) {
            try {
                let promise = new Promise(fetchCurrentAuthToken);
                promise.then((value) => sendModifiedDataFromLeftPanel(value));
            } catch (error) {
                alert("An error has occurred, please check internet connection and try again.");
                console.log(error);
            }
        }
        return;
    }

    async function sendModifiedDataFromLeftPanel(authToken) {
        try {
            const updatedItems = $dbData.modifications.updated ?? [];            
            const ra = formRequestAction("modify", {wpn_id: $dbData.wpn_id, items: updatedItems}, authToken);
            const resModify = await fetch(ra.url, ra.initData);
            const wasSent = (resModify.ok && resModify.status < 300);
            const msg = (wasSent) ? 'Success: Server upupdated' : 'Error: Failed to update server';
            console.log(msg);
        } catch (error) {
            console.error('Error sending modify request: ', error);
        }
        return;
    }

    async function getDB() {
        try {
            await fetchLocalSystemData();
            await fetchUtilityData($dbData.wpn_id);
            console.log("Utility Data from Store: ", $dbData.all);
            await fetchAlfxData($dbData.wpn_id, apiALFXSL);
            await fetchAlfxData($dbData.wpn_id, apiALFXSEN);
            await fetchAlfxData($dbData.wpn_id, apiCORR);
            console.log("ALFX data from Store: ", $dbData.alfx_data);
            mapWPN = await makeNewMap($dbData.utility_item)
            mapPrefs.setMapInstance(mapWPN);
            // console.log("Map from store: ", $mapPrefs.mapInstance.center);
            initMapManager($mapPrefs, $sysData);
            // initMapManager(mapWPN, $mapPrefs, $sysData);
            refreshMap($dbData);
            setMapListeners();
        } catch (err) {
            console.log(err);
        }
    }

    async function makeNewMap(utility) {
        const homeSpan = new mapkit.CoordinateSpan(0.005, 0.01);
        const homeCoord = coordinateOfMappable(utility) ?? new mapkit.Coordinate(42.330042, -71.450022);
        const region = new mapkit.CoordinateRegion(homeCoord, homeSpan);
        let map = new mapkit.Map("map1", {
            region: region
        });
        map.showsMapTypeControl = true;
        map.showsPointsOfInterest = false;
        map.showsScale = mapkit.FeatureVisibility.Visible;
        return map;
    }

    async function fetchUtilityData(wpn_id) {
        try {
            const urlDB = apiUrl + wpn_id + apiDB;
            const resDB = await fetch(urlDB);
            if (resDB.ok) {
                const dataDB = await resDB.json();
                dbData.setDatabase(dataDB);
                dbData.emptyUpdatesStore();
                const utility = firstItemWithValueForKey('wpn2_type', 'Utility', $dbData.all['Utility']) ?? {};
                dbData.setUtility(utility);
                const loginUserItem = firstItemWithValueForKey('login_email', $dbData.user_login_email, dbData['Person']) ?? {};
                dbData.setUser(loginUserItem);
            }
        } catch (error) {
            console.error('Error fetching Database JSON: ', error);
        }
    }

    async function fetchAlfxData(wpn_id, api) {
        try {
            const url = apiUrl + wpn_id + api;
            const res = await fetch(url, {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors'
            });
            if (res.ok) {
                const data = await res.json();
                dbData.setALFXData(data);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            const eName = {apiALFXSEN: 'Sensor', apiALFXSL: 'SoundLocation', apiCORR: 'Correlation'}[api];
            dbData.setALFXData({eName: []});
            console.error('Error fetching JSON: ', eName, error);
            return false;
        }
    }

    async function setMapListeners() {
        if (!mapWPN) return;
        mapWPN.addEventListener("deselect", () => { itemToSelect = null; });
        mapWPN.addEventListener("region-change-end", () => {
            refreshMap($dbData);
            const annotation = mapWPN.annotations.find(
                ({ data }) => data?.mappable?.uuid === itemToSelect?.uuid
            );
            mapWPN.selectedAnnotation = annotation || null;
        });
    }

    async function fetchLocalSystemData() {
        try {
            const resSys = await fetch("/data/WPN2X-System.json");
            const dataSys = await resSys.json();
            sysData.set(dataSys);
        } catch (error) {
            console.error('Error fetching System JSON: ', error);
        }
        try {
            const resSchema = await fetch("/data/WPN2X-Schema.json");
            const dataSchema = await resSchema.json();
            schemaData.importSchema(dataSchema);
        } catch (error) {
            console.error('Error fetching Schema JSON: ', error);
        }
    }

    function searchMapForTextMatch(event) {
        itemToSelect = searchDatabase(event.detail.text, $dbData.alfx_data) ?? searchDatabase(event.detail.text, $dbData.all);
        showCalloutForSelectedItem();
    }

    function showSearchItemOnMap(event) {
        detailItem = event.detail.item;
        findItemOnMap(event);
    }

    function findItemOnMap(event) {
        itemToSelect = event.detail.item;
        showCalloutForSelectedItem();
    }

    function showCalloutForSelectedItem() {
        if (itemToSelect != undefined && mapWPN) {
            adjustMapPreferencesForItem(itemToSelect);
            panMapToItem(itemToSelect);
            const annotation = mapWPN.annotations.find((x) => x.data.mappable.uuid === itemToSelect?.uuid);
            mapWPN.selectedAnnotation = annotation;
        }
    }

    function adjustMapPreferencesForItem(item) {
        if ($mapPrefs.infrastructures.includes(item.infrastructure) == false) {
            var infraData = [...$mapPrefs.infrastructures, item.infrastructure];
            mapPrefs.updateInfrastructures(infraData);
        }
        const cat = allCategories().find((x) => x.entities.includes(item.entity)) ?? "";
        if ($mapPrefs.categories.includes(cat) == false) {
            var catData = [...$mapPrefs.categories, cat];
            mapPrefs.updateCategories(catData);
        }
    }

    function refreshMapWithPreferences() {
        modalMode = "none";
        refreshMap($dbData);
    }

    function setSearchCategory(event) {
        if (mapWPN) {
            mapWPN.selectedAnnotation = null;
            searchCat = allCategories().find((x) => x.name == event.detail.cat);
            browseOpts.setDefault()
        }
        detailItem = null;
    }

    async function reloadAnalysisData(event) {
        await fetchAlfxData($dbData.wpn_id, apiALFXSL);
        await fetchAlfxData($dbData.wpn_id, apiCORR);
        const result = await fetchAlfxData($dbData.wpn_id, apiALFXSEN);
        if (result == true) {
            alert("Success: Analysis has been reloaded");
        } else {
            alert("An error occurred while refreshing analysis: please sign out and try again");
        }
        console.log("ALFX Data from Store: ", $dbData.alfx_data);
        refreshMap($dbData);
    }

    function showAnalysis() {
        closeLeftPanel();
        modalMode = "analysis";
    }

</script>

<Navbar
    utility={$dbData.utility_item}
    on:sign-out
    on:alfx={setSearchCategory}
    on:work={setSearchCategory}
    on:assets={setSearchCategory}
    on:support={() => (modalMode = "support")}
    on:view={() => (modalMode = "view")}
    on:analysis={showAnalysis}
    on:search={searchMapForTextMatch}
/>
<div class="mapBox">
    <div id="map1" />
</div>

{#if searchCat != null}
    <LPMainView
        bind:detailItem
        bind:searchCat
        on:close-search-table={() => {searchCat = null; closeLeftPanel();}}
        on:select={showSearchItemOnMap}
        on:find-on-map={findItemOnMap}
        on:create={() => (modalMode = "create")}
        on:edit={() => (modalMode = "edit")}
    />
{/if}
{#if modalMode == "view"}
    <WPNModal
        {modalMode}
        contentType="view-cards"
        on:close={refreshMapWithPreferences}
    />
{:else if modalMode == "support"}
    <WPNModal
        {modalMode}
        contentType="help-request"
        on:close={() => (modalMode = "none")}
    />
{:else if modalMode == "analysis"}
    <WPNModal
        {modalMode}
        contentType="none"
        on:close={() => (modalMode = "none")}
        on:reload_analysis={reloadAnalysisData}
    />
{/if}
    <!-- {:else if modalMode == "create"}
    <WPNModal
        {modalMode}
        contentType={searchCat.value}
        on:close={() => (modalMode = "none")}
    /> -->
<!-- {:else if modalMode == "edit"}
    <WPNModal
        {modalMode}
        selectedItem={detailItem}
        contentType={searchCat.value}
        on:close={() => (modalMode = "none")}
    /> -->

<style>
    .mapBox {
        position: absolute;
        width: 100%;
        height: calc(100% - 49px);
        top: 49px;
        background-color: silver;
    }
    #map1 {
        width: 100%;
        height: 100%;
    }
    :global(.title-label) {
        font-size: 1.1rem;
        font-weight: 400;
        margin: 0 auto;
        padding-left: 0.5rem;
    }
    :global(.subtitle-label) {
        font-size: 0.85rem;
        line-height: 1.05;
        margin: 0 0;
    }
    :global(.subtitle-line-1) {
        padding: 0.5rem 0 0 0.5rem;
    }
    :global(.subtitle-line-2) {
        padding: 0.15rem 0 0 0.5rem;
    }
    :global(.more-link-btn) {
        position: absolute;
        top: -14px;
        right: -16px;
    }
    :global(th) {
        background-color: lightgray;
        border-top: 0.5px solid rgb(230, 230, 230);
        border-collapse: collapse;
        padding: 8px;
        cursor: pointer;
    }
    :global(.non-sortable) {
        cursor: default;
    }
    :global(h2) {
        color: rgb(67, 148, 11);
        font-size: x-large;
        font-weight: 300;
        text-align: center;
    }
    :global(label) {
        font-size: 15px;
        color:  #242424;
        font-weight: 200;
        display: flex;
        margin: auto auto 0.25rem auto;
        vertical-align: baseline;
        max-width: 100%;
    }
    :global(td) {
        border-left: 1px solid #f5efef;
        border-bottom: 1px solid #e6e6e6;
        border-collapse: collapse;
        padding: 0 4px;
        margin: 0 auto;
        width: auto;
        height: 1.5rem;
    }
    :global(.action-col) {
        border-bottom: 1px solid #e6e6e6;
        border-collapse: collapse;
        cursor: pointer;
    }
    :global(hr) {
        display: block;
        margin-top: 0.5em;
        margin-bottom: 0.5em;
        margin-left: auto;
        margin-right: auto;
        border-style: inset;
        border-width: 0.25px;
    }
    :global(a.active-link) {
        color: dodgerblue;
        text-align: center;
        font-size: 0.9rem;
        padding-right: 4px;
    }
    :global(a.inactive-link) {
        pointer-events: none;
        color: gray;
        text-align: center;
        font-size: 0.9rem;
        padding-right: 4px;
    }
    :global(a.link-spacer) {
        pointer-events: none;
        color: lightgray;
        text-align: center;
        font-size: 1em;
        padding: 0 4px;
    }
    :global(.right-buttons-panel) {
        flex: 1;
        text-align: right;
        padding-bottom: 8px;
        padding-right: 4px;
    }
</style>
